// extracted by mini-css-extract-plugin
export default {"about":"About_about__U6j+1","heading":"About_heading__Mb4fm","motivate":"About_motivate__Qp9vO","fullWidth":"About_fullWidth__6TO9m"};